import { useEffect, useRef, useState } from "react"
import Header from "../../../layouts/Header"
import { styled, createTheme, ThemeProvider } from "@mui/material/styles"
import { Box, Button } from "@mui/material"

import BackIcon from "../../../components/BackIcon"
import CustomFieldsetAccordion from "../../../components/CustomFieldsetAccordion"
import CustomFieldset from "../../../components/CustomFieldset"
import CustomDatePicker from "../../../components/CustomDatePicker"
import CustomTextField from "../../../components/CustomTextField"
import CustomHelperDetail from "../../../components/CustomHelperDetail"
import dayjs, { Dayjs } from "dayjs"
import CustomRadioButtonGroup from "../../../components/CustomRadioButtonGroup"
import CustomTooltip from "../../../components/ToolTip"
import EjecutarIcon from "../../../assets/iconos/EjecutarAccion.ico"
import CustomMultiRowSelectionAprobado from "./components/CustomMultiRowSelectionAprobado"
import CustomMultiRowSelectionNoAprobado from "./components/CustomMultiRowSelectionNoAprobado"
import fetchwrapper from "../../../services/interceptors/fetchwrapper"
import Swal from "sweetalert2"

const StyledRoot = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  marginTop: theme.spacing(8),
  flexGrow: 1,
  padding: "0 16px",
  height: "100vh",
}))

const theme = createTheme({
  palette: {
    primary: {
      main: "#196C87",
    },
    secondary: {
      main: "#196C87", // Cambia el color secundario a verde azulado
    },
  },
})

// *************************************************
//             ContainerCriteriosBusqueda
// ************************************************
const ContainerCriteriosBusqueda = styled(Box)(({ theme }) => ({
  display: "grid",
  gridTemplateColumns: "repeat(12, 1fr)",
  gridTemplateAreas: `
    "IProveedor IProveedor IProveedor IProveedor IProveedor IProveedor IProveedor IProveedor IProveedor IProveedor IProveedor IProveedor"
    "IVencDesde IVencDesde IVencDesde IVencDesde IVencDesde IVencDesde IVencHasta IVencHasta IVencHasta IVencHasta IVencHasta IVencHasta"
    "CPagos CPagos CPagos CPagos CPagos CPagos CPagos CPagos CPagos CPagos CPagos CPagos"
    "CImprimir CImprimir CImprimir CImprimir CImprimir CImprimir CImprimir CImprimir CImprimir CImprimir CImprimir CImprimir"
    "CAcciones CAcciones CAcciones CAcciones CAcciones CAcciones CAcciones CAcciones CAcciones CAcciones CAcciones CAcciones"
  `,
  gap: "8px",
  alignItems: "center",
  // Versión para pantallas pequeñas
  [theme.breakpoints.down("md")]: {
    gridTemplateColumns: "1fr",
    gridTemplateAreas: `
      "IProveedor"
      "IVencDesde"
      "IVencHasta"
      "CPagos"
      "CImprimir"
      "CAcciones"
    `,
    gap: "12px",
  },
}))

const IProveedor = styled(Box)({
  gridArea: "IProveedor",
})

// *************************************************
//             ContainerPagos (CPagos)
// ************************************************
const ContainerPagos = styled(Box)(({ theme }) => ({
  display: "grid",
  gridTemplateColumns: "repeat(12, 1fr)",
  gridTemplateAreas: `
    "IPagosCbx IPagosCbx IPagosCbx IPagosCbx IPagosCbx IPagosCbx IPagosCbx IPagosCbx IPagosCbx IPagosCbx IPagosCbx IPagosCbx"
  `,
  gap: "8px",
  alignItems: "center",
  // Versión para pantallas pequeñas
  [theme.breakpoints.down("md")]: {
    gridTemplateColumns: "1fr",
    gridTemplateAreas: `
      "IPagosCbx"
    `,
    gap: "12px",
  },
}))

const IPagosCbx = styled(Box)({
  gridArea: "IPagosCbx",
})
const IVencDesde = styled(Box)({ gridArea: "IVencDesde" })
const IVencHasta = styled(Box)({ gridArea: "IVencHasta" })
const CPagos = styled(Box)({ gridArea: "CPagos" })
const CImprimir = styled(Box)({ gridArea: "CImprimir" })
const CAcciones = styled(Box)({ gridArea: "CAcciones" })

// *************************************************
//             ContainerImpimir (CImpimir)
// ************************************************
const ContainerImpimir = styled(Box)(({ theme }) => ({
  display: "grid",
  gridTemplateColumns: "repeat(12, 1fr)",
  gridTemplateAreas: `
    "IAgrupacionCbx IAgrupacionCbx IAgrupacionCbx IAgrupacionCbx IAgrupacionCbx IAgrupacionCbx IAgrupacionCbx IAgrupacionCbx IAgrupacionCbx IAgrupacionCbx IAgrupacionCbx IAgrupacionCbx"
    "IImprimirBtn IImprimirBtn IImprimirBtn IImprimirBtn IImprimirBtn IImprimirBtn IImprimirBtn IImprimirBtn IImprimirBtn IImprimirBtn IImprimirBtn IImprimirBtn"
  `,
  gap: "8px",
  alignItems: "center",
  // Versión para pantallas pequeñas
  [theme.breakpoints.down("md")]: {
    gridTemplateColumns: "1fr",
    gridTemplateAreas: `
      "IAgrupacionCbx"
      "IImprimirBtn"
    `,
    gap: "12px",
  },
}))
const IAgrupacionCbx = styled(Box)({
  gridArea: "IAgrupacionCbx",
})
const IImprimirBtn = styled(Box)({
  gridArea: "IImprimirBtn",
})

// *************************************************
//             ContainerAcciones (CAcciones)
// ************************************************
const ContainerAcciones = styled(Box)(({ theme }) => ({
  display: "grid",
  gridTemplateColumns: "repeat(12, 1fr)",
  gridTemplateAreas: `
      "IAproDesapBtn IAproDesapBtn IAproDesapBtn IAproDesapBtn IAproDesapBtn IAproDesapBtn IAproDesapBtn IAproDesapBtn IAproDesapBtn IAproDesapBtn IAproDesapBtn IAproDesapBtn"
  `,
  gap: "8px",
  alignItems: "center",
  // Versión para pantallas pequeñas
  [theme.breakpoints.down("md")]: {
    gridTemplateColumns: "1fr",
    gridTemplateAreas: `
      "IAproDesapBtn"
    `,
    gap: "12px",
  },
}))

const IAproDesapBtn = styled(Box)({
  gridArea: "IAproDesapBtn",
})

// *************************************************
//            AprobacionSolicitudPagoCrear
// ************************************************

const AprobacionSolicitudPagoCrear = () => {
  const [mostrarComponente, setMostrarComponente] = useState(true) // Controla que solo se muestren los componente cuando se da click en ejecutar busqueda
  const [refreshCustomMultiRowSelectionRefKey, setRefreshCustomMultiRowSelectionRefKey] = useState(1) // <-- Controla el reinicio del table cada vez que se de click en la busqueda
  // Nuevo estado para forzar recarga completa de datos
  const [forceDataRefresh, setForceDataRefresh] = useState(0)

  const [criterioBusqueda, setCriterioBusqueda] = useState({
    proveedor: null,
    vencimientoDesde: dayjs(null),
    vencimientoHasta: dayjs(null),
    pagoAprobacion: { value: "noAprobado", label: "No Aprobados" },
  })
  const handleSetCriterioBusqueda = (k, v) => setCriterioBusqueda((prev) => ({ ...prev, [k]: v }))
  const [expandedCriterioBusqueda, setExpandedCriterioBusqueda] = useState(false)
  const handleToggleCriterioBusqueda = () => {
    setExpandedCriterioBusqueda((prev) => !prev)
  }
  const handleSearching = () => {
    setRefreshCustomMultiRowSelectionRefKey((prev) => prev + 1)
    setForceDataRefresh((prev) => prev + 1)
    setMostrarComponente(true)
    setExpandedCriterioBusqueda(false)
  }
  const handleAprobacionDesaprobacionPago = () => {
    console.log(criterioBusqueda, "aquiiiiiiizzz")
    return alert("aprob desaprov pago")
  }

  const handleSelectedData = async (allRecords) => {
    // Para los registros aprobados solo enviere a la api aquellos que estan seleccionados
    // mientras para los que no estan aprobados enviare todos, ya que se puede dar el caso
    // de que modifique un celda editable de un registro que no esta seleccinado entonces
    // este debere actulizarse en la api
    let infoSentToApi = []

    if (criterioBusqueda?.pagoAprobacion?.value === "noAprobado") {
      infoSentToApi = allRecords
        .filter((item) => item.isSelected) // Solo los seleccionados
        .map((item) => ({
          ...item.originalData, // Todos los datos originales
          ...item.editableFields, // Sobrescribe con los campos editados
        }))
    } else {
      infoSentToApi = allRecords.map((item) => ({
        ...item.originalData, // Todos los datos originales
        ...item.editableFields, // Sobrescribe con los campos editados
        isSelected: item.isSelected,
      }))
    }

    try {
      const options = {
        method: "POST",
        body: JSON.stringify({
          registros: infoSentToApi,
          optSolicitud1: criterioBusqueda?.pagoAprobacion?.value === "noAprobado",
        }),
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
        },
      }

      const response = await fetchwrapper(`/AprobacionSolicitudPago/saveAprobacionSolicitudesPago`, options)

      await Swal.fire({
        icon: "success",
        title: "Operación exitosa",
        text: response?.message,
      })

      // Forzar recarga completa de datos después del guardado exitoso
      setRefreshCustomMultiRowSelectionRefKey((prev) => prev + 1)
      setForceDataRefresh((prev) => prev + 1)
      setMostrarComponente(true)

      return response?.message
    } catch (errorResponse) {
      Swal.fire({
        title: "Error",
        text: errorResponse?.details?.msg || "Error al guardar la aprobacióm",
        icon: "error",
        confirmButtonText: "OK",
      })
    }
  }

  return (
    <ThemeProvider theme={theme}>
      <Header />
      <div className="main main-app p-3 p-lg-4">
        <BackIcon />
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            margin: "0 30px 30px 30px",
            fontSize: "25px",
          }}
        >
          <b>Aprobación Sollicitud de Pago</b>
        </div>
        <div style={{ display: "flex", flexDirection: "row", gap: "10px" }}>
          <div style={{ paddingTop: "10px", paddingBottom: "10px" }}>
            <CustomTooltip title={"Buscar"}>
              <Button style={{ fontSize: "0.9vw" }} onClick={handleSearching}>
                <img src={EjecutarIcon} alt="Crear" style={{ width: "40px" }} />
              </Button>
            </CustomTooltip>
          </div>
        </div>

        <Box className={StyledRoot}>
          <CustomFieldsetAccordion
            title="Criterio de Búsqueda"
            expanded={expandedCriterioBusqueda}
            onToggle={handleToggleCriterioBusqueda}
          >
            <ContainerCriteriosBusqueda>
              <IProveedor>
                <CustomHelperDetail
                  label="Proveedor"
                  valueSearched={criterioBusqueda.proveedor?.procodigo}
                  endpoint="/OCGerenciaAdquisiciones/getProveedoresHelper"
                  valueInputMain="procodigo"
                  valueInputSecondary="pronombre"
                  idSearchField="procodigo"
                  errorMsgIdSearch="Error fetching data:"
                  errorMsgFilterSearch="Error en cargar datos"
                  queryKeyModal="proveedoresGerenciaAdquisiciones"
                  perPage={10}
                  placeholder=""
                  columnsTable={[
                    {
                      accessorKey: "procodigo",
                      header: "Código",
                      size: 100,
                      Cell: ({ cell }) => {
                        const value = cell.getValue()
                        return <span>{value}</span>
                      },
                    },
                    {
                      accessorKey: "pronombre",
                      header: "Nombre del Proveedor",
                      size: 300,
                      Cell: ({ cell }) => {
                        const value = cell.getValue()
                        return <span>{value}</span>
                      },
                    },
                    {
                      accessorKey: "proruc",
                      header: "RUC",
                      size: 200,
                      Cell: ({ cell }) => {
                        const value = cell.getValue()
                        return <span>{value}</span>
                      },
                    },
                    {
                      accessorKey: "protelef1",
                      header: "Teléfono",
                      size: 200,
                      Cell: ({ cell }) => {
                        const value = cell.getValue()
                        return <span>{value}</span>
                      },
                    },
                    {
                      accessorKey: "prostatusSTR",
                      header: "Estado",
                      size: 100,
                      Cell: ({ cell }) => {
                        const value = cell.getValue()
                        return <span>{value}</span>
                      },
                    },
                  ]}
                  onHandleSelectedData={(v) => handleSetCriterioBusqueda("proveedor", v)}
                  sxInputMain={{
                    minWidth: "170px",
                    maxWidth: "170px",
                    marginRight: "10px",
                  }}
                  sxInputSecondary={{
                    width: "100%",
                  }}
                />
              </IProveedor>
              <IVencDesde>
                <CustomDatePicker
                  label="Vencimiento Desde"
                  value={criterioBusqueda.vencimientoDesde}
                  setValue={(v) => handleSetCriterioBusqueda("vencimientoDesde", v)}
                  isOptional={true}
                  defaultValue={dayjs(new Date())}
                  checkboxInitialChecked={false}
                />
              </IVencDesde>
              <IVencHasta>
                <CustomDatePicker
                  label="Vencimiento Hasta"
                  value={criterioBusqueda.vencimientoHasta}
                  setValue={(v) => handleSetCriterioBusqueda("vencimientoHasta", v)}
                  isOptional={true}
                  defaultValue={dayjs(new Date())}
                  checkboxInitialChecked={false}
                />
              </IVencHasta>

              {/* // *************************************************
              //             ContainerPagos (CPagos)
              // ************************************************ */}
              <CPagos style={{ marginTop: "15px" }}>
                <CustomFieldset title="Pagos">
                  <ContainerPagos>
                    <IPagosCbx>
                      <CustomRadioButtonGroup
                        label=""
                        selectedOption={criterioBusqueda.pagoAprobacion}
                        setSelectedOption={(v) => {
                          handleSetCriterioBusqueda("pagoAprobacion", v)
                          setMostrarComponente(false)
                          // Reiniciar claves cuando cambia el tipo de pago
                          setRefreshCustomMultiRowSelectionRefKey((prev) => prev + 1)
                          setForceDataRefresh((prev) => prev + 1)
                        }}
                        options={[
                          { value: "aprobado", label: "Aprobados" },
                          { value: "noAprobado", label: "No Aprobados" },
                        ]}
                      />
                    </IPagosCbx>
                  </ContainerPagos>
                </CustomFieldset>
              </CPagos>

              {/* // *************************************************
              //             ContainerAcciones (CAcciones)
              // ************************************************ */}
              {/* <CAcciones>
                <CustomFieldset>
                  <ContainerAcciones>
                    <IAproDesapBtn>
                      <Button fullWidth variant="contained" color="primary" onClick={handleAprobacionDesaprobacionPago}>
                        Aprobar/DesAprobar Pago
                      </Button>
                    </IAproDesapBtn>
                  </ContainerAcciones>
                </CustomFieldset>
              </CAcciones> */}
            </ContainerCriteriosBusqueda>
          </CustomFieldsetAccordion>
          {/* // *************************************************
              //             DATAGRID (CPagos)
              // ************************************************ */}
          {refreshCustomMultiRowSelectionRefKey > 0 &&
            mostrarComponente &&
            (criterioBusqueda?.pagoAprobacion?.value === "aprobado" ? (
              <div>
                <CustomMultiRowSelectionAprobado
                  key={`aprobado-${refreshCustomMultiRowSelectionRefKey}-${forceDataRefresh}`}
                  endpoint="/AprobacionSolicitudPago/getFilteredSolicitudesPago"
                  endpointJson={{
                    dtpFecDesC: criterioBusqueda?.vencimientoDesde,
                    dtpFecHasC: criterioBusqueda?.vencimientoHasta,
                    optSolicitud0: criterioBusqueda?.pagoAprobacion?.value === "aprobado",
                    txtCodProF: criterioBusqueda?.proveedor?.procodigo,
                    txtNomProF: criterioBusqueda?.proveedor?.pronombre,
                  }}
                  onHandleSelectedData={handleSelectedData}
                  queryKeyModal={`AprobacionSolicitudPagoCrearAprobado-${forceDataRefresh}`}
                  perPage={10}
                  columnsTable={[
                    {
                      accessorKey: "nombre_cliente",
                      header: "Proveedor",
                      size: 500,
                      Cell: ({ cell }) => <span>{cell.getValue()}</span>,
                    },
                    {
                      accessorKey: "tipo_sri_descrip",
                      header: "Tipo SRI",
                      size: 200,
                      Cell: ({ cell }) => <span>{cell.getValue()}</span>,
                    },
                    {
                      accessorKey: "serie",
                      header: "Número Serie",
                      size: 200,
                      Cell: ({ cell }) => <span>{cell.getValue()}</span>,
                    },
                    {
                      accessorKey: "factura",
                      header: "Número Factura ANT/VIA/CAJA",
                      size: 300,
                      Cell: ({ cell }) => <span>{cell.getValue()}</span>,
                    },
                    {
                      accessorKey: "cuota",
                      header: "Cuota",
                      size: 200,
                      Cell: ({ cell }) => <span>{cell.getValue()}</span>,
                    },
                    {
                      accessorKey: "valor",
                      header: "Valor Cuota",
                      size: 200,
                      Cell: ({ cell }) => <span>${parseFloat(cell.getValue()).toFixed(2)}</span>,
                    },
                    {
                      accessorKey: "ruc_cliente",
                      header: "RUC",
                      size: 200,
                      Cell: ({ cell }) => <span>{cell.getValue()}</span>,
                    },
                    {
                      accessorKey: "pagado",
                      header: "Pagado",
                      size: 120,
                      Cell: ({ cell }) => <span>{cell.getValue()}</span>,
                    },
                    {
                      accessorKey: "saldo",
                      header: "Saldo",
                      size: 120,
                      Cell: ({ cell }) => <span>{cell.getValue()}</span>,
                    },
                    {
                      accessorKey: "vencimiento",
                      header: "Vencimiento",
                      size: 150,
                      Cell: ({ cell }) => <span>{cell.getValue()}</span>,
                    },
                    {
                      accessorKey: "fecha_pago_programado",
                      header: "A pagar el",
                      size: 150,
                      Cell: ({ cell }) => <span>{cell.getValue()}</span>,
                    },
                    {
                      accessorKey: "comentario",
                      header: "Comentario",
                      size: 500,
                      Cell: ({ cell }) => <span>{cell.getValue()}</span>,
                    },
                  ]}
                  editableColumns={[
                    {
                      accessorKey: "fecha_pago_programado",
                      type: "date",
                      defaultValue: "",
                    },
                    {
                      accessorKey: "comentario",
                      type: "text",
                      placeholder: "Agregar comentario",
                      defaultValue: "",
                    },
                  ]}
                />
              </div>
            ) : (
              <div>
                <CustomMultiRowSelectionNoAprobado
                  key={`noAprobado-${refreshCustomMultiRowSelectionRefKey}-${forceDataRefresh}`}
                  endpoint="/AprobacionSolicitudPago/getFilteredSolicitudesPago"
                  endpointJson={{
                    dtpFecDesC: criterioBusqueda?.vencimientoDesde,
                    dtpFecHasC: criterioBusqueda?.vencimientoHasta,
                    optSolicitud0: criterioBusqueda?.pagoAprobacion?.value === "aprobado",
                    txtCodProF: criterioBusqueda?.proveedor?.procodigo,
                    txtNomProF: criterioBusqueda?.proveedor?.pronombre,
                  }}
                  queryKeyModal={`AprobacionSolicitudPagoCrearNoAprobado-${forceDataRefresh}`}
                  perPage={10}
                  onHandleSelectedData={handleSelectedData}
                  columnsTable={[
                    {
                      accessorKey: "nombre_cliente",
                      header: "Proveedor",
                      size: 500,
                      Cell: ({ cell }) => <span>{cell.getValue()}</span>,
                    },
                    {
                      accessorKey: "tipo_sri_descrip",
                      header: "Tipo SRI",
                      size: 200,
                      Cell: ({ cell }) => <span>{cell.getValue()}</span>,
                    },
                    {
                      accessorKey: "serie",
                      header: "Número Serie",
                      size: 200,
                      Cell: ({ cell }) => <span>{cell.getValue()}</span>,
                    },
                    {
                      accessorKey: "factura",
                      header: "Número Factura ANT/VIA/CAJA",
                      size: 300,
                      Cell: ({ cell }) => <span>{cell.getValue()}</span>,
                    },
                    {
                      accessorKey: "cuota",
                      header: "Cuota",
                      size: 200,
                      Cell: ({ cell }) => <span>{cell.getValue()}</span>,
                    },
                    {
                      accessorKey: "valor",
                      header: "Valor Cuota",
                      size: 200,
                      Cell: ({ cell }) => <span>${parseFloat(cell.getValue()).toFixed(2)}</span>,
                    },
                    {
                      accessorKey: "ruc_cliente",
                      header: "RUC",
                      size: 200,
                      Cell: ({ cell }) => <span>{cell.getValue()}</span>,
                    },
                    {
                      accessorKey: "pagado",
                      header: "Pagado",
                      size: 120,
                      Cell: ({ cell }) => <span>{cell.getValue()}</span>,
                    },
                    {
                      accessorKey: "saldo",
                      header: "Saldo",
                      size: 120,
                      Cell: ({ cell }) => <span>{cell.getValue()}</span>,
                    },
                    {
                      accessorKey: "vencimiento",
                      header: "Vencimiento",
                      size: 150,
                      Cell: ({ cell }) => <span>{cell.getValue()}</span>,
                    },
                    {
                      accessorKey: "fecha_pago_programado",
                      header: "A pagar el",
                      size: 150,
                      Cell: ({ cell }) => <span>{cell.getValue()}</span>,
                    },
                    {
                      accessorKey: "comentario",
                      header: "Comentario",
                      size: 500,
                      Cell: ({ cell }) => <span>{cell.getValue()}</span>,
                    },
                  ]}
                  editableColumns={[
                    {
                      accessorKey: "fecha_pago_programado",
                      type: "date",
                      defaultValue: "",
                    },
                    {
                      accessorKey: "comentario",
                      type: "text",
                      placeholder: "Agregar comentario",
                      defaultValue: "",
                    },
                  ]}
                />
              </div>
            ))}
        </Box>
      </div>
    </ThemeProvider>
  )
}

export default AprobacionSolicitudPagoCrear
